// Components/CreateNews/CreateNewsStyle.js

import styled, { keyframes } from "styled-components";

// PÁGINA PRINCIPAL
export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;
export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  max-width: 1200px;
  margin: 0 auto;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 28px;
  }
`;
export const CreateButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  &:hover {
    background: #ffc300;
    transform: translateY(-2px);
  }
`;

// ABAS DE NAVEGAÇÃO
export const TabContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
`;
export const TabButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  background: ${(props) =>
    props.active ? "#E6AA3A" : "rgba(255,255,255,0.1)"};
  color: ${(props) => (props.active ? "#111" : "#fff")};
  border: 1px solid
    ${(props) => (props.active ? "#E6AA3A" : "rgba(255,255,255,0.2)")};
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: ${(props) =>
      props.active ? "#FFC300" : "rgba(255,255,255,0.2)"};
  }
`;

// LISTA E ITENS
export const NewsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
export const NewsItem = styled.li`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  .info {
    display: flex;
    align-items: center;
    gap: 15px;
    min-width: 0;
  }
  img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    object-fit: cover;
    flex-shrink: 0;
  }
  p {
    margin: 0;
    color: #fff;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    font-size: 12px;
    color: #fff;
    opacity: 0.6;
  }
  .actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
`;

// TAG DE STATUS
const getStatusColor = (status) => {
  switch (status) {
    case "PENDENTE":
      return "#f1c40f"; // Amarelo
    case "ATIVA":
      return "#2ecc71"; // Verde
    case "CANCELADA":
      return "#95a5a6"; // Cinza
    default:
      return "#7f8c8d";
  }
};
export const StatusTag = styled.div`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  background-color: ${(props) => getStatusColor(props.status)};
  color: #fff;
  text-transform: uppercase;
`;

// BOTÕES DE AÇÃO
export const ActionButton = styled.button`
  background: ${(props) => (props.color === "green" ? "#27ae60" : "#d35400")};
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  &:hover {
    background: ${(props) => (props.color === "green" ? "#2ecc71" : "#e67e22")};
  }
`;
export const EditButton = styled(ActionButton)`
  background: #2980b9;
  &:hover {
    background: #3498db;
  }
`;
export const DeleteButton = styled(ActionButton)`
  background: #c0392b;
  &:hover {
    background: #e74c3c;
  }
`;

// MODAL
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: translateY(-20px) scale(0.95); } to { transform: translateY(0) scale(1); }`;
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease;
  padding: 20px;
  box-sizing: border-box;
`;
export const ModalContent = styled.div`
  background: #282828;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideIn} 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;
export const ModalHeader = styled.div`
  padding: 20px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  h3 {
    margin: 0;
    color: #e6aa3a;
    font-size: 22px;
  }
`;
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  transition: color 0.2s ease;
  &:hover {
    color: #e6aa3a;
  }
`;
export const ModalBody = styled.div`
  padding: 30px;
  overflow-y: auto;
`;
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
  }
  input,
  textarea {
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 12px 15px;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    font-family: inherit;
    transition: border-color 0.2s ease;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
  textarea {
    min-height: 150px;
    resize: vertical;
  }
`;
export const ImagePreview = styled.img`
  width: 100%;
  max-height: 250px;
  border-radius: 6px;
  object-fit: cover;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
  display: none;
`;
export const ModalFooter = styled.div`
  padding: 20px 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  background-color: rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
`;
export const SendButton = styled.button`
  background: #27ae60;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background: #2ecc71;
  }
`;
